'use client';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { CategoryOrBuyingOption } from 'services/categories/types';
import {
  capitalizeText,
  replaceTokensInString
} from '@cat-ecom/common/utils/stringUtils';
import { isCatCardMenu } from './utils';
import { ProductCategories } from 'components/pcc-components';
import { normalizeUrl } from 'utils/url';
import {
  CAT_CARD_MENU_CRITERIA_LANG_ID,
  CAT_CARD_MENU_FRENCH_TITLE,
  CAT_MERCHANDISE_COUNTRY_LIST,
  CAT_MERCHANDISE,
  CATEGORY_NAME
} from './constant';
import { HEADLESS_CATEGORY_PAGE_BASE_PATH } from 'constants/links';

export const ShopByCategoryClient = ({
  categories,
  buyingOptions,
  isMobile = false,
  seoURL = '',
  isCspUser,
  isInstantAccessUser,
  country,
  locale,
  userCountryCode,
  isHeadlessCategoryEnabled
}: {
  categories: Array<CategoryOrBuyingOption>;
  buyingOptions: Array<CategoryOrBuyingOption>;
  isMobile?: boolean;
  seoURL: string;
  isCspUser: boolean;
  isInstantAccessUser: boolean;
  country: string;
  locale: string;
  userCountryCode: string;
  isHeadlessCategoryEnabled?: boolean;
}) => {
  const t = useTranslations();
  const isCatCard = useMemo(() => {
    return isCatCardMenu(country, locale) && (isCspUser || isInstantAccessUser);
  }, [country, isCspUser, isInstantAccessUser, locale]);
  const catCardMenuTitle = useMemo(() => {
    return locale === CAT_CARD_MENU_CRITERIA_LANG_ID.fr_FR
      ? CAT_CARD_MENU_FRENCH_TITLE
      : t('CAT_DEALERPYMTTYPES_CatCard');
  }, [locale, t]);

  const catMerchandise = useMemo(() => {
    if (CAT_MERCHANDISE_COUNTRY_LIST.includes(userCountryCode)) {
      return [
        {
          seoUrlKeyword: CAT_MERCHANDISE.seoUrl,
          name: CAT_MERCHANDISE.title,
          categoryIdentifier: CAT_MERCHANDISE.title,
          imageUrl: '',
          sequence: '6',
          shortDescription: CAT_MERCHANDISE.title,
          nestedCategories: []
        }
      ];
    }
    return [];
  }, [userCountryCode]);

  const TRANSLATIONS = {
    categoriesLabel: t('CHOOSE_A_CATEGORY'),
    buyingOptionLabel: t('BUYING_OPTIONS'),
    CAT_SEARCH_CATEGORY: capitalizeText(t('CAT_SEARCH_CATEGORY')),
    heading: t('PARTS'),
    subHeading: t('SEE_ALL_CATEGORIES'),
    subTitle: replaceTokensInString(
      t('SEE_ALL_CATEGORIES_NAME', {
        0: CATEGORY_NAME
      })
    ),
    ssoLabel: t('ALP_SSRO_TITLE'),
    catCardMenuLabel: catCardMenuTitle
  };

  return (
    <ProductCategories
      categoriesList={categories}
      buyingOptions={[...buyingOptions, ...catMerchandise]}
      translations={TRANSLATIONS}
      url={normalizeUrl(seoURL)}
      isMobile={false}
      isCatCard={isCatCard}
      isHeadlessCategoryEnabled={isHeadlessCategoryEnabled}
      esiteURL={seoURL}
      categoriesPath={HEADLESS_CATEGORY_PAGE_BASE_PATH}
    />
  );
};
